

const currentDate = new Date();
const formattedCurrentDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;
const reviewDate = new Date(currentDate);
reviewDate.setMonth(reviewDate.getMonth() + 6);
const formattedReviewDate = `${reviewDate.getFullYear()}-${(reviewDate.getMonth() + 1).toString().padStart(2, '0')}-${reviewDate.getDate().toString().padStart(2, '0')}`;

export const itemShell = {
  id: '',
  description: '',
  estimated_shipping: '',
  entry_date: formattedCurrentDate,
  featured_image: null,
  extra_images: [],
  is_media_mail: false,
  location: {
    id: 0,
    name: ''
  },
  minimum_return: '',
  source: {
    id: 0,
    name: '',
    type: {
      id: 0,
      type: ''
    },
    area: {
      id: 0,
      city: {
        id: 0,
        city: ''
      },
      state: {
        id: 0,
        state: ''
      }
    }
  },
  statuses: [
    {
      entry_date: formattedCurrentDate,
      status: {
        id: 1,
        name: 'listed'
      },
      sales_channel: {
        id: 1,
        channel: 'ebay',
      },
      review_date: formattedReviewDate,
    },
  ],
  tags: [],
};
